import { IconProps } from './index';

const CheckLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"
                fill="currentColor"
            />
        </svg>
    );
};

export default CheckLine;
